var $74145b912355b5af$exports = {};
$74145b912355b5af$exports = {
    "clear": `Temizle`,
    "invalid": `(ge\xe7ersiz)`,
    "loading": `Y\xfckleniyor...`,
    "noResults": `Sonu\xe7 yok`,
    "valid": `(ge\xe7erli)`
};


export {$74145b912355b5af$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
